<div class="sidenav bg-light "
  style="height: 100vh; position: fixed; left: 0; top: 56px; overflow: hidden; transition: width 0.3s;"
  [style.width]="isOpen ? '250px' : '70px'">
  <div class="sidenav-content" style="height: calc(100vh - 56px); overflow-y: auto;">
    <div class="p-3">
      <ul class="nav flex-column" style="width: 220px;">
        <li class="nav-item" *ngFor="let item of menuItems" style="cursor: pointer;">
          <div class="menuList">
            <a class="nav-link d-flex align-items-center menuName" (click)="toggleSubmenu(item)"
                aria-current="page">
              <span><i class="{{ item.icon }}"></i></span>
              <span class="ms-2 menuName" [class.d-none]="!isOpen">{{ item.title }}</span>
              <span style="margin-left: auto;" [class.d-none]="!isOpen">
                <i *ngIf="item.submenus.length > 0" class="fas ms-auto" [ngClass]="{
                  'fa-chevron-up': item.isSubmenuVisible,
                  'fa-chevron-down': !item.isSubmenuVisible
                }"></i>
              </span>
            </a>
          </div>

          <!-- Submenu list -->
          <ul class="nav flex-column ms-3" *ngIf="item.isSubmenuVisible && isOpen">
            <li class="nav-item" *ngFor="let submenu of item.submenus">
              <a class="nav-link" [routerLink]="submenu.route" (click)="toggleGrandChild(submenu)" routerLinkActive="active">
                {{ submenu.title }}
                <i *ngIf="submenu.grandChildMenus?.length" class="fas ms-2" [ngClass]="{
                  'fa-chevron-up': submenu.isGrandChildVisible,
                  'fa-chevron-down': !submenu.isGrandChildVisible
                }"></i>
              </a>

              <!-- Grandchild menus -->
              <ul class="nav flex-column ms-3" *ngIf="submenu.isGrandChildVisible && isOpen">
                <li class="nav-item" *ngFor="let grandChild of submenu.grandChildMenus">
                  <a class="nav-link" [routerLink]="grandChild.route" routerLinkActive="active">
                    {{ grandChild.title }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
